import * as React from 'react';
import { useEffect, useState } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Box from "@material-ui/core/Box";
import { ApplicationState } from "../../redux/reducers";
import { connect } from "react-redux"
import {
    ArrowRightAlt,
    BusinessCenterOutlined,
    Email,
    LocationOnOutlined,
    PermIdentity,
    Print
} from "@material-ui/icons";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { format } from "date-fns";
import { enums } from "../../enums/enums";
import { IUsuario } from "../../entities/catalogos/IUsuario";
import { Paper } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import { saveMercancias } from "../../redux/actions/mercanciaActions";
import { setSolicitud, setSolicitudCopia } from "../../redux/actions/solicitudActions";
import { initialSolicitud } from "../../redux/reducers/solicitudReducer";
import { initialMercancia } from "../../redux/reducers/mercanciaReducer";
import { setRecoleccionDestino, setRecoleccionOrigen } from "../../redux/actions/recoleccionActions";
import { initialRecoleccionState } from "../../redux/reducers/recoleccionReducer";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { Mercancia } from "../../entities/solicitudes/Mercancia";
import RegistroUsuario from "../datosPersonales/RegistroUsuario";
import TableContainer from "@material-ui/core/TableContainer";
import useCommonApi from '../../api/useCommonApi';
import { ServicioAdicional } from '../../entities/catalogos/ServicioAdicional';
import Checkbox from "@material-ui/core/Checkbox";
import { ICliente } from '../../entities/catalogos/ICliente';
import LoadingDialog from '../controls/LoadingDialog';
import swal from 'sweetalert2'
import { useHistory } from "react-router-dom";
import { setUsuario } from '../../redux/actions/usuarioActions';
import EnviarCorreoDialog from '../controls/EnviarCorreoDialog';
import {IHelp} from '../help/Help';
import {b64toBlob, currencyFormat} from "../../blocks/utility";
import {IRecoleccion} from "../../redux/types/recoleccionActionTypes";
import ConfirmDialog from "../controls/ConfirmDialog";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import Swal from 'sweetalert2';
import { IResultApi } from '../../interfaces/IResultApi';
import { saveCliente } from '../../redux/actions/clienteActions';
import { ILimiteServicioDiarioResponse } from '../../interfaces/ILimiteServicioDiarioResponse';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            width: '100%',
            borderCollapse: 'collapse',
            '& td': {
                paddingLeft: "1em"
            },
            '& td:nth-child(odd)': {
                backgroundColor: "#F8F8F8",
                borderLeft: "3px solid #066336",
                paddingRight: "1em"
            },
            '& tr:last-child td': {
                paddingBottom: "1em"
            }
        },

        tableSummary: {
            width: '100%',
            '& td': {
                paddingLeft: "0"
            },
            '& td.price': {
                textAlign: "right"
            }
        },
        total: {
            color: 'white',
            fontWeight: 'bold'
        },
        mensajePrecio: {
            color: 'white',
        },
        mainTitle: {
            color: "#19754e",
            fontSize: "18px",
            fontWeight: "bold"
        },
        title: {
            color: "#19754e",
            fontSize: "10px",
            fontWeight: "bold",
            marginTop: "2em",
            marginBottom: "0.2em",
            '& td': {
                paddingTop: "1em",
                paddingBottom: "0.2em"
            }
        },
        link: {
            color: "#0094ff",
            fontSize: "12px",
            fontWeight: 500,
            cursor: "pointer"
        },
        information: {
            color: "#212121",
            fontSize: "14px",
            fontWeight: 500
        },
        additional: {
            color: " rgba(49,49,49,0.87)",
            fontSize: "12px"
        },
        facturador: {
            color: "#19754e",
            fontSize: "10px",
            fontWeight: "bold",
            marginTop: "2em",
            marginBottom: "0.2em",
            '& td': {
                paddingTop: "2em",
                paddingBottom: "0.2em"
            },
        },
        seccionTitulo: {
            color: "#338462"
        },
        noborder: {
            borderLeft: "none !important",
            paddingRight: "none !important",
            backgroundColor: "#Fff !important",
        },
        infoCliente: {
            fontSize: "12px"
        },
    }),
);

interface OwnProps {
    cotizacionId: number
    siguienteSeccion: (siguienteSeccionId: number, datosSeccion: any, cotizacion_ID: number, proyecto?: any, usuario?: IUsuario) => void
    datosRemitente?: any
    datosDestinatario?: any

}

interface StateProps {
    solicitud: Solicitud
    usuario: IUsuario
    mercancias: Mercancia[]
    solicitudCopia: Solicitud
    serviciosAdicionales: ServicioAdicional[]
    cliente: ICliente
    recoleccionOrigen: IRecoleccion
    recoleccionDestino: IRecoleccion
    ayuda: IHelp
}

interface DispatchProps {
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
    saveMercancias: typeof saveMercancias
    setRecoleccionOrigen: typeof setRecoleccionOrigen
    setRecoleccionDestino: typeof setRecoleccionDestino
    setUsuario: typeof setUsuario
    saveCliente: typeof saveCliente
}

interface IResultAuthApi extends IResultApi {
    response: { token: string, refreshToken: string }
}

interface IDatosLogin {
    resultAuthApi: IResultAuthApi
    cliente: ICliente
    etiquetas: any,
    idioma: string,
    diasRAD: string,
    tieneConveniosHD: boolean
}

type Props = StateProps & DispatchProps & OwnProps & IDatosLogin;

const apiSource = useCommonApi();
const ResumenCotizacion = (props: Props) => {

    const classes = useStyles();
    const [fechaRad, setFechaRad] = useState("");
    const [fechaEad, setFechaEad] = useState("");
    const [registrarUsuario, setRegistrarUsuario] = useState(false);
    const [showLoading, setLoading] = useState(false);
    const [aceptaTerminos, setAceptaTerminos] = useState(false);
    const history = useHistory();
    const [precision, setPrecision] = useState(2);
    const [showEnviarCorreo, setShowEnviarCorreo] = useState(false);
    const [habilitaSolicitud, setHabilitaSolicitud] = useState(false);
    const [opcionesEnvio, setOpcionesEnvio] = useState({dialogOpen: false, terminado: false});
    sessionStorage.setItem("cotizacionCompletada", "true");

    useEffect(() => {
        if (props.solicitud.id == 0) {
            setFechaRad(props.solicitud.fechaCitaRad ? format(props.solicitud.fechaCitaRad, 'dd MMM yyyy h:mm a') : "");
            setFechaEad(props.solicitud.fechaCitaEad ? format(props.solicitud.fechaCitaEad, 'dd MMM yyyy h:mm a') : "");
        }
        else {
            //Nueva y modifica cotizacion
            var clienteNuevaConfig = localStorage.getItem("clienteString")?.toString() !==null ? (localStorage.getItem("clienteString")?.toString() !==undefined ? localStorage.getItem("clienteString") : "") :"" ;
            var clienteObject =  clienteNuevaConfig !== null ? (clienteNuevaConfig !== "" ? JSON.parse(clienteNuevaConfig) : "") : "";
            if(clienteObject === ""){
                let resultCliente:any;
                actualizaLoginData(Number(props.cliente.id), Number(props.usuario.id), localStorage.getItem("usuario_nombre")).then(result => {
            
                    let documentoId = 0;
                    if (result !== null && result.cliente !== null && result.cliente?.id !== null) {
                        result.cliente.habilitarDatosGenericos = result.cliente.clienteConfiguracionDatosGenericos?.datosGenericos;
                        result.cliente.habilitarDatosComplementarios = false;
                        if (result.cliente.clienteConfiguracionComplemento && result.cliente.clienteConfiguracionComplemento.datosComplementariosCartaPorte) {
                            result.cliente.habilitarDatosComplementarios = true;
                        }
                        if (result.cliente.clienteConfiguracionComplementoCartaPorte && result.cliente.clienteConfiguracionComplementoCartaPorte.activo) {
                            result.cliente.habilitarDatosComplementariosCartaPorte = true;
                        }
                        if (result.cliente.clienteConfiguracionCompCartaPorteDetalle && result.cliente.clienteConfiguracionCompCartaPorteDetalle.activo) {
                            result.cliente.habilitarDatosCompCartaPorteDetalle = true;
                        }
                        if (result.cliente.clienteConfiguracionMarkup && result.cliente.clienteConfiguracionMarkup) {
                            result.cliente.clienteConfiguracionMarkup = result.cliente.clienteConfiguracionMarkup;
                        }
                        if (result.cliente.clienteConfiguracionValidacionCoberturaEAD && result.cliente.clienteConfiguracionValidacionCoberturaEAD.activo) {
                            result.cliente.habilitarValidacionCoberturaEAD = true;
                        }
                        if (result.cliente.clienteConfiguracionValidacionCoberturaRAD && result.cliente.clienteConfiguracionValidacionCoberturaRAD.activo) {
                            result.cliente.habilitarValidacionCoberturaRAD = true;
                        }
                        //Se comenta esta linea para colocar siempre en false (0) la variable y así no mostrar nunca la sección markup
                        result.cliente.clienteConfiguracionMarkupDetalle = result.cliente.clienteConfiguracionMarkupDetalle === null ? 0 : result.cliente.clienteConfiguracionMarkupDetalle;
                        //result.cliente.clienteConfiguracionMarkupDetalle = 0;

                        if (result.cliente?.documentos !== null) {
                            result.cliente.documentos?.forEach(d => {
                                documentoId++;
                                d.id = documentoId;
                            });
                        }
                        result.cliente.tieneConveniosHD = result.tieneConveniosHD;
                        localStorage.setItem("etiquetas", JSON.stringify(result.etiquetas));
                        localStorage.setItem("idioma", result.idioma);
                        resultCliente = result.cliente;
                        if(result.diasRAD !== undefined && result.diasRAD !== "" && result.diasRAD !== null){
                            localStorage.setItem("diasRad", result.diasRAD);
                        }
                        else{
                            localStorage.setItem("diasRad", "0");
                        }
                        if(JSON.stringify(props.cliente) !== JSON.stringify(resultCliente)){
                            props.saveCliente(resultCliente);
                            localStorage.setItem("clienteString", JSON.stringify(result.cliente));
                        }
                        let fechaRad = obtieneFechaRadEad(props.solicitud.EsRadCitaFueraHorario, props.solicitud.fechaCitaRad, props.solicitud.RadCitaHoraDe, props.solicitud.RadCitaHoraHasta);
                        let fechaEad = obtieneFechaRadEad(props.solicitud.EsEadCitaFueraHorario, props.solicitud.fechaCitaEad, props.solicitud.EadCitaHoraDe, props.solicitud.EadCitaHoraHasta);
                        let fechaRadCedis = obtieneFechaRadEad(props.solicitud.EsRadCitaFueraHorario, props.solicitud.fechaCitaRadCedis, props.solicitud.RadCitaHoraDe, props.solicitud.RadCitaHoraHasta);
                        let fechaEadCedis = obtieneFechaRadEad(props.solicitud.EsEadCitaFueraHorario, props.solicitud.fechaCitaEadCedis, props.solicitud.EadCitaHoraDe, props.solicitud.EadCitaHoraHasta);
                        setFechaRad(fechaRad);
                        setFechaEad(fechaEad);
                        if(fechaRad=="")
                            setFechaRad(fechaRadCedis);
                        if(fechaEad=="")
                            setFechaEad(fechaEadCedis);
                        if (props.solicitud.EsRadCitaFueraHorario) {
                            fechaRad = obtieneFechaRadEad(props.solicitud.EsRadCitaFueraHorario, props.solicitud.cotizacionCitaHorario?.fechaCitaRad ?? props.solicitud.fechaCitaRad, props.solicitud.RadCitaHoraDe, props.solicitud.RadCitaHoraHasta);
                            setFechaRad(fechaRad);

                        }
                        if (props.solicitud.EsEadCitaFueraHorario) {
                            fechaEad = obtieneFechaRadEad(props.solicitud.EsEadCitaFueraHorario, props.solicitud.cotizacionCitaHorario?.fechaCitaEad ?? props.solicitud.fechaCitaEad, props.solicitud.EadCitaHoraDe, props.solicitud.EadCitaHoraHasta);
                            setFechaEad(fechaEad);
                        }
                    }
                })
            }
        }

        if (props.solicitud.unidadMedidaLongitudId == enums.unidadMedidaLongitud.pulgadas) {
            setPrecision(3);
        }

        setHabilitaSolicitud(true);
    }, []);

    const obtieneFechaRadEad = (esFueraHorario, fecha, horaDe, horaHasta) => {
        let fechaString = "";
        let language = 'es';
        if(localStorage.getItem("idioma")==='en-US'){
            language = 'en';
        }
        if (esFueraHorario) {
            if (fecha !== undefined && fecha !== null) {
                let ampm1 = "";
                let ampm2 = "";
                let hours1 = horaDe.split(':');
                let hours2 = horaHasta.split(':');
                if (parseInt(hours1[0]) > 11)
                    ampm1 = "p.m.";
                else
                    ampm1 = "a.m."

                if (parseInt(hours2[0]) > 11)
                    ampm2 = "p.m.";
                else
                    ampm2 = "a.m."
                let horaDeTiempoh1 = '';
                if (parseInt(hours1[1]) < 10 && (hours1[1].length < 2))
                    horaDeTiempoh1 = hours1[0] + ':0' + hours1[1];
                else
                    horaDeTiempoh1 = horaDe;
                let horaDeTiempoh2 = '';
                if (parseInt(hours2[1]) < 10 && (hours2[1].length < 2)) {
                    horaDeTiempoh2 = hours2[0] + ':0' + hours2[1];
                }

                else {
                    horaDeTiempoh2 = horaHasta;
                }

                fechaString = new Date(fecha).toLocaleString(language, { day: "numeric", month: "short", year: "numeric" })
                    + " " + horaDeTiempoh1 + " " + ampm1 + " - " + horaDeTiempoh2 + " " + ampm2
            }
        }
        else {


            if (fecha !== undefined && fecha !== null) {
                let fechaOffset = new Date(fecha);
                //fechaOffset.setMinutes(fechaOffset.getMinutes() + fechaOffset.getTimezoneOffset())

                const hora = new Date(fechaOffset);

                let ampm1 = "";
                if (fechaOffset.getHours() > 11)
                    ampm1 = "p.m.";
                else
                    ampm1 = "a.m."
                fechaString = new Date(fechaOffset).toLocaleString(language, { day: "numeric", month: "short", year: "numeric" })
                    + " " + (fechaOffset.getHours() < 10 ? '0' : '') + fechaOffset.getHours() + ':' + (fechaOffset.getMinutes() < 10 ? '0' : '') + fechaOffset.getMinutes() + ' ' + ampm1;
            }
        }
        return fechaString;
    }

    const crearNuevaCotizacion = () => {
        setLoading(true);
        let resultCliente:any;
        actualizaLoginData(Number(props.cliente.id), Number(props.usuario.id), localStorage.getItem("usuario_nombre")).then(result => {
            let documentoId = 0;
            if (result !== null && result.cliente !== null && result.cliente?.id !== null) {
                result.cliente.habilitarDatosGenericos = result.cliente.clienteConfiguracionDatosGenericos?.datosGenericos;
                result.cliente.habilitarDatosComplementarios = false;
                if (result.cliente.clienteConfiguracionComplemento && result.cliente.clienteConfiguracionComplemento.datosComplementariosCartaPorte) {
                    result.cliente.habilitarDatosComplementarios = true;
                }
                if (result.cliente.clienteConfiguracionComplementoCartaPorte && result.cliente.clienteConfiguracionComplementoCartaPorte.activo) {
                    result.cliente.habilitarDatosComplementariosCartaPorte = true;
                }
                if (result.cliente.clienteConfiguracionCompCartaPorteDetalle && result.cliente.clienteConfiguracionCompCartaPorteDetalle.activo) {
                    result.cliente.habilitarDatosCompCartaPorteDetalle = true;
                }
                if (result.cliente.clienteConfiguracionMarkup && result.cliente.clienteConfiguracionMarkup) {
                    result.cliente.clienteConfiguracionMarkup = result.cliente.clienteConfiguracionMarkup;
                }
                if (result.cliente.clienteConfiguracionValidacionCoberturaEAD && result.cliente.clienteConfiguracionValidacionCoberturaEAD.activo) {
                    result.cliente.habilitarValidacionCoberturaEAD = true;
                }
                if (result.cliente.clienteConfiguracionValidacionCoberturaRAD && result.cliente.clienteConfiguracionValidacionCoberturaRAD.activo) {
                    result.cliente.habilitarValidacionCoberturaRAD = true;
                }
                //Se comenta esta linea para colocar siempre en false (0) la variable y así no mostrar nunca la sección markup
                result.cliente.clienteConfiguracionMarkupDetalle = result.cliente.clienteConfiguracionMarkupDetalle === null ? 0 : result.cliente.clienteConfiguracionMarkupDetalle;
                //result.cliente.clienteConfiguracionMarkupDetalle = 0;

                if (result.cliente?.documentos !== null) {
                    result.cliente.documentos?.forEach(d => {
                        documentoId++;
                        d.id = documentoId;
                    });
                }
                result.cliente.tieneConveniosHD = result.tieneConveniosHD;
                localStorage.setItem("etiquetas", JSON.stringify(result.etiquetas));
                localStorage.setItem("idioma", result.idioma);
                resultCliente = result.cliente;
                if(result.diasRAD !== undefined && result.diasRAD !== "" && result.diasRAD !== null){
                    localStorage.setItem("diasRad", result.diasRAD);
                }
                else{
                    localStorage.setItem("diasRad", "0");
                }
                if(JSON.stringify(props.cliente) !== JSON.stringify(resultCliente)){
                    props.saveCliente(resultCliente);
                    localStorage.setItem("clienteString", JSON.stringify(result.cliente));
                }
                const nuevaCotizacion = new Solicitud(initialSolicitud);

                props.setSolicitud(nuevaCotizacion);
                props.setSolicitudCopia(nuevaCotizacion);
                props.setRecoleccionOrigen(initialRecoleccionState);
                props.setRecoleccionDestino(initialRecoleccionState);
                props.saveMercancias([initialMercancia]);
                props.setUsuario({ ...props.usuario });
                setLoading(false);
                if (props.usuario.esInvitado) {
                    sessionStorage.removeItem("cotizacionCompletada");
                    sessionStorage.removeItem("UpdateCompletado");
                    history.push("/");
                }
                else {
                    history.push("/nueva-cotizacion");
                }
            }
        })
    };

    const cerrarRegistroUsuario = () => {
        setRegistrarUsuario(false);
    }

    const confirmarRegistroUsuario = () => {
        setRegistrarUsuario(false);
        setLoading(false);
        setHabilitaSolicitud(true);
    }

    const generarSolicituServicio = async () => {

        if (!aceptaTerminos) {
            swal.fire({
                titleText: traducirMessage(276), // '¡Atención!',
                text: traducirMessage(95), // "Favor de aceptar los términos y condiciones.",
                type: 'warning',
            });
            return;
        }

        if(localStorage["tipo_usuario"].toLowerCase() === "invitado"){
            swal.fire({
                titleText: traducirMessage(276), // '¡Atención!',
                text: traducirMessage(301),
                type: 'warning',
                showConfirmButton: true,
                showCloseButton: true,
                confirmButtonAriaLabel: traducirButton(7), // 'Continuar'
                
            }).then((result) => {
                if (result.value == true) {
                    const form = document.createElement("form");
                    form.id = "frmRegistro";
                    form.method = "POST";
                    form.action = process.env.REACT_APP_URL_FORM_REGISTRY + "";
                    
                    const idCotizacionInv = document.createElement('input');
                    idCotizacionInv.type = 'hidden';
                    idCotizacionInv.id = 'idCotizacionInvitado';
                    idCotizacionInv.name = 'idCotizacionInvitado';
                    idCotizacionInv.value = props.solicitud.id.toString();
                    form.appendChild(idCotizacionInv);

                    const nombreInvitado = document.createElement('input');
                    nombreInvitado.type = 'hidden';
                    nombreInvitado.id = 'nombreInvitado';
                    nombreInvitado.name = 'nombreInvitado';
                    nombreInvitado.value = props.solicitud.nombreInv+"";
                    form.appendChild(nombreInvitado);

                    const apellidoInvitado = document.createElement('input');
                    apellidoInvitado.type = 'hidden';
                    apellidoInvitado.id = 'apellidoInvitado';
                    apellidoInvitado.name = 'apellidoInvitado';
                    apellidoInvitado.value = props.solicitud.apellidoInv+"";
                    form.appendChild(apellidoInvitado);

                    const telefonoInv = document.createElement('input');
                    telefonoInv.type = 'hidden';
                    telefonoInv.id = 'telefonoInvitado';
                    telefonoInv.name = 'telefonoInvitado';
                    telefonoInv.value = props.solicitud.telefonoTarifaAlmex+"";
                    form.appendChild(telefonoInv);

                    const correo = document.createElement('input');
                    correo.type = 'hidden';
                    correo.id = 'correoInvitado';
                    correo.name = 'correoInvitado';
                    correo.value = props.solicitud.correo+"";
                    form.appendChild(correo);

                    const Lang = document.createElement('input');
                    Lang.type = 'hidden';
                    Lang.id = 'Lang';
                    Lang.name = 'Lang';
                    Lang.value = localStorage.getItem("idioma")+"";
                    form.appendChild(Lang);

                    document.body.appendChild(form);
                    form.submit();
                }
                
            })
        }

        else{
            if (!habilitaSolicitud) {
                setRegistrarUsuario(true);
                return;
            }
            setLoading(true);

            const resLimite = await apiSource.postAsync<ILimiteServicioDiarioResponse>("solicitud-servicio/validar-limite-servicio-diario/" + props.cliente.id);
            if (resLimite && resLimite.permitirSolicitud === false) {
                setLoading(false);
                const limite = resLimite.limiteServiciosDiarios ?? (resLimite as any).limiteServicioDiario ?? 0;
                const msg = traducirMessage(370);
                const textMessage = msg.replace('{0}', limite.toString());
                swal.fire({
                    titleText: traducirMessage(11), // '¡Aviso!',
                    text: textMessage,
                    type: 'warning',
                });
                history.push("/");
                return;
            }

            const copiaSolicitud = new Solicitud(props.solicitud);
            const url = `unidad/validar-unidad?clienteId=${encodeURIComponent(String(props.cliente.id))}&unidadPesoId=${encodeURIComponent(String(props.solicitudCopia.unidadMedidaPesoId))}&unidadMedidaId=${encodeURIComponent(String(props.solicitudCopia.unidadMedidaLongitudId))}`;

            const apiResult = await apiSource.postAsync<any>(url);
            
            if (!apiResult.success) {
                swal.fire({
                    titleText: traducirMessage(11), // '¡Aviso!',
                    text: apiResult.message || "Error en la validación de unidades",
                    type: 'warning'
                });
                setLoading(false);
                return;
            }

            copiaSolicitud.id = 0;
            copiaSolicitud.cotizacionId = props.solicitud.id;
            copiaSolicitud.seccionId = enums.estatusSolicitud.inicial;
            copiaSolicitud.estatusId = enums.estatusSolicitud.inicial;
            copiaSolicitud.completada = false;
            copiaSolicitud.modificar = true;
            copiaSolicitud.tipoSolicitud = "solicitud servicio";
            copiaSolicitud.documentosRetorno = [];
            copiaSolicitud.tipoDocumento = 2;
            copiaSolicitud.tipoDeRecoleccionDestino = 1;
            const fechaDefaultEAD = new Date('1900-01-01T00:00:00');
            const esEadCitaCedis = (
                copiaSolicitud.serviciosAdicionalesDestino?.some(servicio => servicio?.id === 50) ||
                copiaSolicitud.serviciosAdicionales?.some(servicio => servicio?.id === 50)
            ) ? true : false;
            if (copiaSolicitud.fechaCitaEad && fechaDefaultEAD.getFullYear() !== copiaSolicitud.fechaCitaEad.getFullYear()){
                copiaSolicitud.tipoDeRecoleccionDestino = 2;
            }
            if (copiaSolicitud.fechaCitaEadCedis && esEadCitaCedis === true){
                copiaSolicitud.tipoDeRecoleccionDestino = 4;
            }
            if (copiaSolicitud.EsEadCitaFueraHorario && copiaSolicitud.EsEadCitaFueraHorario === true) {
                copiaSolicitud.tipoDeRecoleccionDestino = 3;
            }
            let resultCliente:any;
            
            actualizaLoginData(Number(props.cliente.id), Number(props.usuario.id), localStorage.getItem("usuario_nombre")).then(result => {
    
                let documentoId = 0;
                if (result !== null && result.cliente !== null && result.cliente?.id !== null) {
                    result.cliente.habilitarDatosGenericos = result.cliente.clienteConfiguracionDatosGenericos?.datosGenericos;
                    result.cliente.habilitarDatosComplementarios = false;
                    if (result.cliente.clienteConfiguracionComplemento && result.cliente.clienteConfiguracionComplemento.datosComplementariosCartaPorte) {
                        result.cliente.habilitarDatosComplementarios = true;
                    }
                    if (result.cliente.clienteConfiguracionComplementoCartaPorte && result.cliente.clienteConfiguracionComplementoCartaPorte.activo) {
                        result.cliente.habilitarDatosComplementariosCartaPorte = true;
                    }
                    if (result.cliente.clienteConfiguracionCompCartaPorteDetalle && result.cliente.clienteConfiguracionCompCartaPorteDetalle.activo) {
                        result.cliente.habilitarDatosCompCartaPorteDetalle = true;
                    }
                    if (result.cliente.clienteConfiguracionMarkup && result.cliente.clienteConfiguracionMarkup) {
                        result.cliente.clienteConfiguracionMarkup = result.cliente.clienteConfiguracionMarkup;
                    }
                    if (result.cliente.clienteConfiguracionValidacionCoberturaEAD && result.cliente.clienteConfiguracionValidacionCoberturaEAD.activo) {
                        result.cliente.habilitarValidacionCoberturaEAD = true;
                    }
                    if (result.cliente.clienteConfiguracionValidacionCoberturaRAD && result.cliente.clienteConfiguracionValidacionCoberturaRAD.activo) {
                        result.cliente.habilitarValidacionCoberturaRAD = true;
                    }
                    //Se comenta esta linea para colocar siempre en false (0) la variable y así no mostrar nunca la sección markup
                    result.cliente.clienteConfiguracionMarkupDetalle = result.cliente.clienteConfiguracionMarkupDetalle === null ? 0 : result.cliente.clienteConfiguracionMarkupDetalle;
                    //result.cliente.clienteConfiguracionMarkupDetalle = 0;
    
                    if (result.cliente?.documentos !== null) {
                        result.cliente.documentos?.forEach(d => {
                            documentoId++;
                            d.id = documentoId;
                        });
                    }
                    result.cliente.tieneConveniosHD = result.tieneConveniosHD;
                    localStorage.setItem("etiquetas", JSON.stringify(result.etiquetas));
                    localStorage.setItem("idioma", result.idioma);
                    resultCliente = result.cliente;
                    props.saveCliente(resultCliente);
                    
                    if(result.diasRAD !== undefined && result.diasRAD !== "" && result.diasRAD !== null){
                        localStorage.setItem("diasRad", result.diasRAD);
                    }
                    else{
                        localStorage.setItem("diasRad", "0");
                    }
                    props.setSolicitudCopia(copiaSolicitud);
                    props.setSolicitud(copiaSolicitud);
                    if(props.recoleccionOrigen.EsCitaRadCedis){
                        props.setRecoleccionOrigen({ ...props.recoleccionOrigen, completado: false, fechaCita: undefined});
                    }
                    else{
                        props.setRecoleccionOrigen({...props.recoleccionOrigen, completado: false});
                    }
                    if(props.recoleccionDestino.EsCitaEadCedis){
                        props.setRecoleccionDestino({ ...props.recoleccionDestino, completado: false, fechaCita: undefined});
                    }
                    else{
                        props.setRecoleccionDestino({...props.recoleccionDestino, completado: false});
                    }
                    
                    history.push("/nueva-solicitud");
                    setLoading(true);
                }
            })


           
        }
    };

    const actualizaLoginData = async (clienteId, usuarioId, userName) => {
        const result = await apiSource.obtenerAsync<IDatosLogin>("login/login-data", { clienteId: clienteId, usuarioId: usuarioId });
        return result;
    };

    const validaCliente = async (cliente) => {
        let params = {
            clienteId: cliente.toString(),
            modulo: "COTIZACION EXTERNO NUEVO",
            evento: "CREAR SOLICITUD A PARTIR DE COTIZACIÓN",
            username: localStorage.getItem("usuario_nombre")
        };
        const result = await apiSource.postAsync<number>("solicitud-servicio/valida-cliente-datos-cFDI", params);
        return result;
    }

    const aceptaterminos = () => {
        window.open('http://ndocum.almex.com.mx/documentacion/pages/GenerarPDF.aspx?TipoPDF=8');
    }

    const materialesPeligrosos = () => {
        window.open('https://www.almex.com.mx/recursos/articulos-prohibidos/');
    }

    const imprimir = (esDesdeConfirmacion) => {
        if (!opcionesEnvio.terminado && !esDesdeConfirmacion) {
            setOpcionesEnvio({...opcionesEnvio, dialogOpen: true});
            return;
        }

        setLoading(true);
        imprimirCall().then(response => {
            setLoading(false);

            const blob = b64toBlob(response, 'application/pdf');
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            let fileName = "";
            fileName = "Cotizacion-" + props.solicitud.id + ".pdf";
            link.download = fileName;
            link.click();
        }).catch((error) => {
            setLoading(false);
            swal.fire({
                titleText: traducirMessage(276), // '¡Atención!',
                text: traducirMessage(212), // "Ocurrio un error al imprimir el formato de la cotización..",
                type: 'error',
            });
        });
    }

    const imprimirCall = async () => {
        const result = await apiSource.postAsync<any>("/cotizacion/pdf-sharp-convert/" + props.solicitud.id);
        return result;
    }

    const enviarCorreo = () => {
        setShowEnviarCorreo(true);
    }

    const handleTerminos = () => {
        setAceptaTerminos(true);
    }

    const confirmarEnviarCorreo = (esTerminarSolicitud) => {
        swal.fire({
            titleText: traducirMessage(14), // '¡Exitoso!',
            text: traducirMessage(54), // "El correo fue enviado exitosamente.",
            type: 'success',
        });

        setShowEnviarCorreo(false);

        if (esTerminarSolicitud) {
            terminarSolicitud(false);
        }
    }

    const cerrarEnviarCorreo = () => {
        setShowEnviarCorreo(false);
    }

    const terminarSolicitud = (esImprimir: boolean) => {
        const solicitudCopia = new Solicitud(props.solicitud);
        solicitudCopia.enviada = true;
        props.setSolicitud(solicitudCopia);

        if(esImprimir){
            imprimir(true);
        }
        setOpcionesEnvio({...opcionesEnvio, dialogOpen: false, terminado: true});
    }

    return (<>
        {!registrarUsuario &&
            <>
                <Paper>
                    <Box display="flex" px={3} pt={2} alignItems="center" flexWrap="wrap">

                        <Box className={classes.mainTitle} flexGrow={1}>
                            {/* COTIZACIÓN  */ traducirLabel(58)} {props.solicitud.id}
                        </Box>

                        {props.solicitudCopia.tipoSolicitud !== 'cotizacion' &&
                            <Box className={classes.mainTitle} flexGrow={1}>
                                {/* SOLICITUD SERVICIO  */traducirLabel(284)} {props.solicitudCopia.numGuia}
                            </Box>
                        }

                        <Box m={1}>
                            
                                <Button variant="outlined" color="primary" onClick={crearNuevaCotizacion}>
                                    {/* Crear Nueva Cotización */ traducirLabel(62)}
                                </Button>
                            
                        </Box>
                        <Box m={1}>
                            {!props.usuario.esInvitado &&
                                <Button variant="outlined" color="primary" onClick={() => generarSolicituServicio()}>
                                    {/* Generar Solicitud de Servicio */ traducirLabel(148)}
                                </Button>
                            }
                        </Box>

                        {props.solicitudCopia.tipoSolicitud === 'cotizacion' &&
                            <Box m={1}>

                                <Button color="primary" onClick={() => imprimir(false)}>
                                    <Print /> {/* Imprimir */ traducirLabel(164)}
                                </Button>
                                <Button color="primary" onClick={enviarCorreo}>
                                    <Email /> {/* Enviar por Email */traducirLabel(121)}
                                </Button>
                            </Box>
                        }
                    </Box>

                    <Box p={3} pt={2}>
                        <Divider />

                        <Grid container spacing={2}>
                            <Grid item xs={12} md={8}>
                                <Box display="flex" flexDirection="column">
                                    <Box display="flex" mb={1} mt={3}>
                                        <PermIdentity />
                                        <Box ml={1}>
                                            <b className={classes.seccionTitulo}>
                                                {/* Datos Cliente */ localStorage["tipo_usuario"].toLowerCase() === "invitado" ? traducirLabel(70) : traducirLabel(67)}
                                            </b>
                                        </Box>
                                    </Box>

                                    <Box ml={4}>
                                        <table >
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: "400px" }} className={classes.infoCliente} >
                                                        <Box><strong>{!props.solicitudCopia.nombreTarifaAlmex ? props.cliente.nombre : props.solicitudCopia.nombreTarifaAlmex}</strong></Box>
                                                        <Box>{props.solicitudCopia.empresaTarifaAlmex}</Box>
                                                        <Box>{!props.solicitudCopia.telefonoTarifaAlmex ? props.cliente.telefono : props.solicitudCopia.telefonoTarifaAlmex}</Box>
                                                        <Box>{props.solicitud.correo}</Box>
                                                    </td>
                                                    <td>
                                                        {props.cliente.grupoClienteID >= 0 && (props.cliente.clienteCreditoProyecto && props.cliente.clienteCreditoProyecto?.length >= 2) &&
                                                            <Box><strong>
                                                                {/* PROYECTO */traducirLabel(241)}
                                                            </strong><br /><span>{props.solicitudCopia.proyecto?.descripcion}</span></Box>

                                                        }
                                                    </td>
                                                    <td className={classes.infoCliente}>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Box>
                                </Box>

                                <Box display="flex" flexDirection="column" mt={3}>
                                    <Box display="flex" mb={1}>
                                        <LocationOnOutlined />
                                        <Box ml={1}><b className={classes.seccionTitulo}>
                                            {/* Origen y Destino */ traducirLabel(223)}
                                        </b></Box>
                                    </Box>

                                    <table className={classes.root}>
                                        <tbody>

                                            <tr className={classes.title}>
                                                <td style={{ width: "45%" }}>
                                                    {/* ORIGEN */traducirLabel(222)}
                                                </td>
                                                <td style={{ width: "10%" }} />
                                                <td style={{ width: "45%" }}>
                                                    {/* DESTINO */traducirLabel(86)}
                                                </td>
                                            </tr>
                                            <tr style={{ fontSize: "16px", color: "rgba(0,0,0,0.87)", fontWeight: 500 }}>
                                                <td>
                                                    {props.solicitudCopia.tipoRecoleccionIdOrigen === enums.tipoRecoleccion.ocurre ?
                                                        `${props.solicitudCopia.sucursalOrigen?.ciudad.nombre} ${props.solicitudCopia.sucursalOrigen?.estado.nombre ?? ''}`
                                                        : props.solicitudCopia.coloniaOrigen?.direccionResumen}

                                                    <ul style={{ margin: 0, paddingLeft: "1.5em" }}>
                                                        {fechaRad && <li>{fechaRad}</li>}

                                                        {localStorage.getItem("idioma") === 'en-US' && props.solicitud.serviciosAdicionalesOrigen?.filter(sa => !(props.solicitud.esServicioInternacional && sa.id === enums.servicioAdicional.retornoDocumentos)).map(sa =>
                                                            sa.seleccionado ? <li key={sa.id}>{sa.etiquetaServicioAdicionalDto?.nombre == null ? sa.nombre : sa.etiquetaServicioAdicionalDto.nombre }</li> : null
                                                        )
                                                        }
                                                        {localStorage.getItem("idioma") !== 'en-US' && props.solicitud.serviciosAdicionalesOrigen?.filter(sa => !(props.solicitud.esServicioInternacional && sa.id === enums.servicioAdicional.retornoDocumentos)).map(sa =>
                                                            sa.seleccionado ? <li key={sa.id}>{sa.nombre}</li> : null
                                                        )
                                                        }
                                                    </ul>
                                                </td>
                                                <td><ArrowRightAlt style={{ verticalAlign: "middle" }} /></td>
                                                <td>
                                                    {props.solicitud.tipoRecoleccionIdDestino === enums.tipoRecoleccion.ocurre ?
                                                        `${props.solicitud.sucursalDestino?.ciudad.nombre} ${props.solicitud.sucursalDestino?.estado.nombre ?? ''} `
                                                        : props.solicitud.coloniaDestino?.direccionResumen}
                                                    <ul style={{ margin: 0, paddingLeft: "1.5em" }}>
                                                        {fechaEad && <li>{fechaEad}</li>}

                                                        {localStorage.getItem("idioma") !== 'en-US' && props.solicitud.serviciosAdicionalesDestino?.filter(sa => !(props.solicitud.esServicioInternacional && sa.id === enums.servicioAdicional.retornoDocumentos)).map(sa =>
                                                            sa.seleccionado ? <li key={sa.id}>{sa.nombre}</li> : null
                                                        )
                                                        }
                                                        {localStorage.getItem("idioma") === 'en-US' && props.solicitud.serviciosAdicionalesDestino?.filter(sa => !(props.solicitud.esServicioInternacional && sa.id === enums.servicioAdicional.retornoDocumentos)).map(sa =>
                                                            sa.seleccionado ? <li key={sa.id}>{sa.etiquetaServicioAdicionalDto?.nombre == null ? sa.nombre : sa.etiquetaServicioAdicionalDto.nombre }</li> : null
                                                        )
                                                        }
                                                    </ul>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Box>

                                <Box display="flex" flexDirection="column" mt={3}>
                                    <Box display="flex" mb={1}>
                                        <BusinessCenterOutlined />
                                        <Box ml={1}><b className={classes.seccionTitulo}>
                                            {/* Detalle de Mercancía */traducirLabel(88)}
                                        </b></Box>
                                    </Box>

                                    <Box ml={4}>
                                        <TableContainer component={Paper}>
                                            <Table className="table-xs" size="small" aria-label="a dense table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center">
                                                            {/* No. */traducirLabel(193)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* Cant. */traducirLabel(29)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* Embalaje */traducirLabel(111)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* Largo x Ancho x Alto */traducirLabel(174)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* Volumen */traducirLabel(320)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* Peso */traducirLabel(229)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* No Estibable */traducirLabel(190)}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {props.mercancias?.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">{index + 1}</TableCell>
                                                            <TableCell align="center"> {row.cantidad}</TableCell>
                                                            {(localStorage.getItem("idioma") === 'en-US') &&
                                                                <TableCell align="center">{row.etiquetaEmbalaje?.nombre !== undefined ? row.etiquetaEmbalaje?.nombre : (row.embalaje?.etiquetaEmbalaje != undefined ? row.embalaje?.etiquetaEmbalaje?.nombre : row.embalaje)}</TableCell>
                                                            }
                                                            {(localStorage.getItem("idioma") !== 'en-US') &&
                                                                <TableCell align="center">{row.embalaje?.nombre != undefined ? row.embalaje?.nombre : row.embalaje}</TableCell>
                                                            }
                                                            <TableCell
                                                                align="center">{`${Number(row.largo)?.toFixed(2)} x ${Number(row.ancho).toFixed(2)} x ${Number(row.alto).toFixed(2)}`}</TableCell>
                                                            <TableCell align="center">{Number(row.volumen).toFixed(precision)}</TableCell>
                                                            <TableCell align="center">{Number.isInteger(row.peso ?? 0) ? row.peso : row.peso?.toFixed(3)}</TableCell>
                                                            {localStorage.getItem("idioma") === 'en-US' &&
                                                                <TableCell align="center">{row.esEstibable ? 'Yes' : 'No'}</TableCell>
                                                            }
                                                            {localStorage.getItem("idioma") !== 'en-US' &&
                                                                <TableCell align="center">{row.esEstibable ? 'Si' : 'No'}</TableCell>
                                                            }
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>
                                    {habilitaSolicitud &&
                                        <Box ml={4}>
                                            <div>
                                                <table>
                                                    <tr>
                                                        <td>
                                                            {!props.usuario.esInvitado &&
                                                            <Checkbox name="aplicaOrigen" color="primary" size="small" checked={aceptaTerminos}
                                                                onChange={handleTerminos} />
                                                            }
                                                        </td>
                                                        <td>
                                                            <span className={classes.link} onClick={aceptaterminos}>
                                                                {/* Acepto t&eacute;rminos y condiciones */traducirLabel(3)}
                                                            </span>
                                                        </td>
                                                        <td style={{ width: "300px", textAlign: "center" }}>
                                                            <span className={classes.link} onClick={materialesPeligrosos}>
                                                                {/* Materiales Peligrosos */traducirMessage(184)}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </Box>
                                    }
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Box style={{ backgroundColor: "#f5f5f5" }}>
                                    <Box p={3}>
                                        {props.cliente.monedaID == 1 &&
                                            <>
                                                <Button variant="contained">MXN</Button>
                                                <Button variant="outlined" disabled={true}>USD</Button>
                                            </>
                                        }
                                        {props.cliente.monedaID != 1 &&
                                            <>
                                                <Button variant="outlined" disabled={true}>MXN</Button>
                                                <Button variant="contained" >USD</Button>
                                            </>
                                        }

                                        <Box className={classes.title}>
                                            {/* ENVÍO */traducirLabel(122)}
                                        </Box>

                                        <Box className={classes.information}>
                                            {props.solicitud.tipoEnvio?.nombre}
                                        </Box>

                                        <Box className={classes.title}>
                                            {/* SERVICIO */traducirLabel(276)}
                                        </Box>

                                        <Box className={classes.information}>
                                            {props.solicitudCopia.tipoServicio?.nombre}
                                        </Box>

                                        {props.cliente.esClase == true &&
                                            <>
                                                <Box className={classes.title}>
                                                    {/* Clase */
                                                        traducirLabel(34)}
                                                </Box>

                                                <Box className={classes.information}>
                                                    {props.solicitud.clase}
                                                </Box>
                                            </>
                                        }

                                        <table className={classes.tableSummary} style={{ marginTop: '0.7em' }}>
                                            <tbody>
                                                <tr className={classes.title}>
                                                    <td colSpan={2}>
                                                        {/* PESO FACTURADO */traducirLabel(230)}
                                                    </td>
                                                </tr>
                                                <tr className={classes.information}>
                                                    {localStorage.getItem("idioma")!=='en-US' &&
                                                        <td>{props.solicitud.totalPesoFacturado ? props.solicitud.totalPesoFacturado : 0}  {props.solicitud.unidadMedidaPesoId == 1 ? 'kg.' : 'Lib.'} </td>
                                                    }
                                                    {localStorage.getItem("idioma")==='en-US' &&
                                                        <td>{props.solicitud.totalPesoFacturado ? props.solicitud.totalPesoFacturado : 0}  {props.solicitud.unidadMedidaPesoId == 1 ? 'kg.' : 'Pound.'} </td>
                                                    }
                                                    
                                                    <td className="price">{props.solicitud.montoPesoFacturado ? currencyFormat(props.solicitud.montoPesoFacturado) : currencyFormat(0)}
                                                    </td>
                                                </tr>
                                                <tr className={classes.title}>
                                                    <td colSpan={2} style={{ paddingTop: '2em' }}>
                                                        {/* SERVICIOS ADICIONALES */traducirLabel(278)}
                                                    </td>
                                                </tr>


                                                {localStorage.getItem("idioma") === 'en-US' && props.solicitud.serviciosAdicionales?.map(sa => sa.concepto?.nombreConcepto && sa.concepto?.nombreConcepto !== 'A.P.C.' && sa.concepto?.nombreConcepto !== 'FLETE CRUCE FRONTERIZO' && sa.concepto?.nombreConcepto !== 'INTRA USA' &&
                                                    <tr className={classes.information} key={sa.id}>
                                                        <td>{sa.concepto?.etiquetaConcepto?.nombreConcepto == null ? sa.concepto.nombreConcepto : sa.concepto.etiquetaConcepto.nombreConcepto}</td>
                                                        <td className="price">{currencyFormat(sa.costo)}</td>
                                                    </tr>
                                                )}

                                                {localStorage.getItem("idioma") !== 'en-US' && props.solicitud.serviciosAdicionales?.map(sa => sa.concepto?.nombreConcepto && sa.concepto?.nombreConcepto !== 'A.P.C.' && sa.concepto?.nombreConcepto !== 'FLETE CRUCE FRONTERIZO' && sa.concepto?.nombreConcepto !== 'INTRA USA' &&
                                                    <tr className={classes.information} key={sa.id}>
                                                        <td>{sa.concepto?.nombreConcepto}</td>
                                                        <td className="price">{currencyFormat(sa.costo)}</td>
                                                    </tr>
                                                )}

                                                {localStorage.getItem("idioma") === 'en-US' && props.solicitud.serviciosAdicionales?.map(sa => sa.nombre && sa.nombre !== 'A.P.C.' && sa.concepto?.nombreConcepto !== 'FLETE CRUCE FRONTERIZO' && sa.concepto?.nombreConcepto !== 'INTRA USA' &&
                                                    <tr className={classes.information} key={sa.id}>
                                                        <td>{sa.etiquetaServicioAdicionalDto?.nombre == null ? sa.nombre : sa.etiquetaServicioAdicionalDto.nombre }</td>
                                                        <td className="price">{currencyFormat(sa.costo)}</td>
                                                    </tr>
                                                )}

                                                {localStorage.getItem("idioma") !== 'en-US' && props.solicitud.serviciosAdicionales?.map(sa => sa.nombre && sa.nombre !== 'A.P.C.' && sa.concepto?.nombreConcepto !== 'FLETE CRUCE FRONTERIZO' && sa.concepto?.nombreConcepto !== 'INTRA USA' &&
                                                    <tr className={classes.information} key={sa.id}>
                                                        <td>{sa.nombre}</td>
                                                        <td className="price">{currencyFormat(sa.costo)}</td>
                                                    </tr>
                                                )}

                                                {localStorage.getItem("idioma") === 'en-US' && props.solicitud.serviciosAdicionales?.map(sa => sa.concepto?.nombreConcepto && sa.concepto?.nombreConcepto === 'A.P.C.' &&

                                                    <tr className={classes.information} key={sa.id}>
                                                        <td>{(sa.concepto?.etiquetaConcepto?.nombreConcepto == null || sa.concepto?.etiquetaConcepto?.nombreConcepto === '') ? sa.concepto.nombreConcepto : sa.concepto.etiquetaConcepto.nombreConcepto}</td>
                                                        <td className="price">{currencyFormat(sa.costo)}</td>
                                                    </tr>
                                                )}
                                                {localStorage.getItem("idioma") !== 'en-US' && props.solicitud.serviciosAdicionales?.map(sa => sa.concepto?.nombreConcepto && sa.concepto?.nombreConcepto === 'A.P.C.' &&

                                                <tr className={classes.information} key={sa.id}>
                                                    <td>{sa.concepto?.nombreConcepto}</td>
                                                    <td className="price">{currencyFormat(sa.costo)}</td>
                                                </tr>
                                                )}

                                                {/* ESTA SECCION ESTARA COMENTADA HASTA QUE SE DEFINAN EL PROCESO DE MARKUP*/
                                                props.solicitud.markupMonto != undefined && props.solicitud.markupMonto > 0 &&
                                                    <>
                                                        <tr className={classes.information}>
                                                            <td>
                                                                {/* MARKUP */ traducirMessage(181)}
                                                            </td>
                                                            <td className="price">{currencyFormat(props.solicitud.markupMonto)}</td>
                                                        </tr>
                                                    </>
                                                }

                                                <tr className={classes.title}>
                                                    <td colSpan={2} style={{ paddingTop: '2em' }}>
                                                        {/* TIPO DE SEGURO */traducirLabel(302)}
                                                    </td>
                                                </tr>
                                                <tr className={classes.information}>
                                                    <td>{props.solicitudCopia.esSeguroBasico ? traducirLabel(273) : props.solicitudCopia.esSeguroMercancia ? traducirLabel(274) : ''}</td>
                                                    <td className="price">{props.solicitud.esSeguroBasico ? currencyFormat(Number(props.solicitud.costoSeguro)) : currencyFormat(Number(props.solicitud.valorMercancia) * .01)}</td>
                                                </tr>
                                                <tr style={{ height: '40px' }}>
                                                    <td colSpan={2}>
                                                        <Divider />
                                                    </td>
                                                </tr>

                                                <tr className={classes.information}
                                                    style={{ height: '35px', verticalAlign: 'bottom' }}>
                                                    <td>
                                                        {/* Subtotal */traducirLabel(287)}
                                                    </td>
                                                    <td className="price">{props.solicitud.subtotal ? currencyFormat(props.solicitud.subtotal) : currencyFormat(0)}</td>
                                                </tr>

                                                <tr className={classes.information}>
                                                    <td>
                                                        {/* IVA */traducirLabel(166)}
                                                    </td>
                                                    <td className="price">{props.solicitud.iva ? currencyFormat(props.solicitud.iva) : currencyFormat(0)}</td>
                                                </tr>

                                                <tr className={classes.information}>
                                                    <td>
                                                        {/* Retención IVA */traducirLabel(267)}
                                                    </td>
                                                    <td className="price">{props.solicitud.retencion ? currencyFormat(props.solicitud.retencion) : currencyFormat(0)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Box>

                                    <Box style={{ backgroundColor: "#338462" }}>
                                        <Box px={3} py={2}>
                                            <table className={classes.tableSummary}>
                                                <tbody>
                                                    <tr className={classes.total}>
                                                        <td>
                                                            {/* TOTAL */traducirLabel(305)}
                                                        </td>
                                                        <td className="price">{props.solicitud.total ? currencyFormat(props.solicitud.total) : currencyFormat(0)}</td>
                                                    </tr>
                                                    <tr style={{ height: '40px', color: 'white' }}>
                                                        <td colSpan={2}>
                                                            <Divider />
                                                        </td>
                                                    </tr>
                                                    <tr className={classes.mensajePrecio}>
                                                        <td>
                                                            {/* * Precios sujetos a medición y pesaje de la mercancía. */traducirMessage(8)}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </>
        }

        {registrarUsuario &&
            <RegistroUsuario cerrar={cerrarRegistroUsuario} confirmar={confirmarRegistroUsuario} abierto={registrarUsuario} />
        }

        {
            showLoading &&
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }

        {showEnviarCorreo &&
            <EnviarCorreoDialog tipo="cotizacion" cerrar={cerrarEnviarCorreo} abierto={showEnviarCorreo}
                                registroId={props.solicitud.id} confirmar={confirmarEnviarCorreo}
                                abrirConfirmar={!opcionesEnvio.terminado}/>
        }

        {opcionesEnvio.dialogOpen &&
        // "Al imprimir ya no podrá hacer modificaciones ¿Desea continuar?"
            <ConfirmDialog titulo={traducirLabel(164)} abierto={opcionesEnvio.dialogOpen}
                           confirmar={()=> terminarSolicitud(true)}
                           contenido={traducirMessage(277)}
                           cerrar={() => setOpcionesEnvio({...opcionesEnvio, dialogOpen: false})}/>
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    solicitud: state.solicitud,
    usuario: state.usuario,
    mercancias: state.mercancias,
    solicitudCopia: state.solicitudCopia,
    cliente: state.cliente,
    recoleccionOrigen: state.recoleccionOrigen,
    recoleccionDestino: state.recoleccionDestino,
    ayuda: state.ayuda
});

const mapDispatchToProps = {
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
    setRecoleccionOrigen: setRecoleccionOrigen,
    setRecoleccionDestino: setRecoleccionDestino,
    saveMercancias: saveMercancias,
    setUsuario: setUsuario,
    saveCliente: saveCliente
};
sessionStorage.removeItem("cotizacionCompletada");
sessionStorage.removeItem("UpdateCompletado");
export default connect(mapStateToProps, mapDispatchToProps)(ResumenCotizacion);
